module.exports = __webpack_public_path__ + "static/thumbnail-the-switch-58708b819f3512c2ac61b1f7f3a655ed.jpg";